import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import MainWrapper from '../MainWrapper';
import NotFound404 from '../../DefaultPage/404/index';
import LogInForm from '../../../shared/components/login/LogInForm';
import ResetPassword from '../../../shared/components/login/ResetPasswordForm';
import WrappedRoutes from './WrappedRoutes';


// import mapFull from '../../Page/ArcGis/mapArcGisFull';


// MCCOSTA: ROTAS PARA LOGIN 
const Router = () => (
  <MainWrapper>
    <main>
      <Switch>
        <Route exact path="/">
          <Redirect to="/forms/home" />
        </Route>
        <Route exact path="/home">
          <Redirect to="/forms/home" />
        </Route>

        
      {/* <Route path="/mapFull" component={mapFull} /> */}

        {/* <Route exact path="/old_home" component={Landing} /> */}
        <Route path="/404" component={NotFound404} />
        {/* <Route path="/lock_screen" component={LockScreen} /> */}
        <Route path="/log_in" component={LogInForm} />
        <Route path="/reset_password" component={ResetPassword} />
        {/* <Route path="/log_in_photo" component={LogInPhoto} /> */}
        <Route path="/" component={WrappedRoutes} />
      </Switch>
    </main>
  </MainWrapper>
);

export default Router;
